import { IApplicationData } from "../../model/application-data";
import { IAuthenticationData } from "../../model/authentication-data";
import { IAuthenticationResponse } from "../../model/security/response/authentication-response";
import { ISessionTokensResponse } from "../../model/security/response/session-tokens-response";
import LocalEnvironment from "./local-environment";
import { getProductName } from "./govhub-brand";
import { resolveModuleKey } from "./module-hostname";

// Módulo e URLs das APIs a partir do hostname (fora de localhost)
export const buildApplicationData = (hostname: string): IApplicationData => {

    var applicationData = {} as IApplicationData;

    var url = hostname.toLowerCase();

    var moduleKey = resolveModuleKey(url);

    var moduleApi: string = moduleKey;

    var autenticacaoApi = "autenticacao";

    if (url.includes("sand")) {
        moduleApi += "-sand";
        autenticacaoApi += "-sand";
    }

    if (moduleKey === "sdp") {
        applicationData.moduleId = 1
        applicationData.moduleName = "SDP"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Diagramação e Publicação";
    } else if (moduleKey === "scp") {
        applicationData.moduleId = 9
        applicationData.moduleName = "SCP"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Contratações Públicas";
    } else if (moduleKey === "sge") {
        applicationData.moduleId = 10
        applicationData.moduleName = "SGE"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Emendas Parlamentares";
    } else if (moduleKey === "apm") {
        applicationData.moduleId = 3
        applicationData.moduleName = "APM"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Gestão de Portal da Entidade";
    } else if (moduleKey === "ser") {
        applicationData.moduleId = 2
        applicationData.moduleName = "SER"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Envio de Remessas";
    } else if (moduleKey === "ouv") {
        applicationData.moduleId = 7
        applicationData.moduleName = "OUV"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Ouvidoria";
    } else if (moduleKey === "sic") {
        applicationData.moduleId = 4
        applicationData.moduleName = "SIC"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Serviço de Informação ao Cidadão";
    } else if (moduleKey === "ged") {
        applicationData.moduleId = 8
        applicationData.moduleName = "GED"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Gestão Eletrônica de Documentos";
    } else if (moduleKey === "adm") {
        applicationData.moduleId = 11
        applicationData.moduleName = "ADM"
        applicationData.initialPage = "dashboard";
        applicationData.moduleDescription = "Administração da Empresa";
    }

    if (url.includes("ipmbrasil")) {
        applicationData.multitenant = 7
        applicationData.baseUrlAuthentication = "http://account.api.ipmbrasil.org.br/";
        applicationData.baseUrl = moduleApi === "apm" || moduleApi === "ser" || moduleApi === "ouv" || moduleApi === "sic" || moduleApi === "ged" || moduleApi === "adm" ? `http://${moduleApi}.api.ipmbrasil.org.br/` : "http://scp.api.ipmbrasil.org.br/";
    } else if (url.includes("docgedsistemas")) {
        applicationData.multitenant = 3851
        applicationData.baseUrlAuthentication = `https://api.${autenticacaoApi}.docgedsistemas.com.br/`;
        applicationData.baseUrl = `https://api.${moduleApi}.docgedsistemas.com.br/`;
    } else if (url.includes("airdoc")) {
        applicationData.multitenant = 3901
        applicationData.baseUrlAuthentication = `https://api.${autenticacaoApi}.airdoc.com.br/`;
        applicationData.baseUrl = `https://api.${moduleApi}.airdoc.com.br/`;
    }

    return applicationData;
};

const getApplicationData = (): IApplicationData => {

    var url = window.location.hostname.toLowerCase();

    var applicationData = LocalEnvironment.isLocalhost() ? LocalEnvironment.getApplicationData() : buildApplicationData(url);

    applicationData.productName = getProductName(applicationData.moduleId);
    applicationData.isSandbox = url.includes("sand");

    return applicationData;
};

const getAuthenticationData = (): IAuthenticationData | undefined => {
    let value = localStorage.getItem("session_application") as string;
    return JSON.parse(value);
};

const setAuthenticationData = (data: IAuthenticationResponse) => {
    const application = Object.assign({} as IAuthenticationData, data)
    localStorage.setItem("session_application", JSON.stringify(application));
};

const clearAuthenticationData = () => {
    localStorage.removeItem("session_application");
};

// Nome e e-mail alterados pelo perfil: a sessão (lida pelas telas) acompanha; o token só muda no próximo login
const updateSessionUser = (patch: { name?: string; email?: string }) => {
    const current = getAuthenticationData();
    if (!current?.user) return;
    const user = { ...current.user };
    if (patch.name) user.name = patch.name;
    if (patch.email) user.email = patch.email;
    localStorage.setItem("session_application", JSON.stringify({ ...current, user }));
};


// Tokens renovados pelo refresh token: usuário e empresa da sessão continuam os mesmos
const updateSessionTokens = (tokens: ISessionTokensResponse) => {
    const current = getAuthenticationData();
    if (!current) return;
    localStorage.setItem("session_application", JSON.stringify({
        ...current,
        bearerToken: tokens.bearerToken,
        expiresAt: tokens.expiresAt,
        refreshToken: tokens.refreshToken,
        refreshTokenExpiresAt: tokens.refreshTokenExpiresAt
    }));
};


const ApplicationAppService = {
    getAuthenticationData, setAuthenticationData, clearAuthenticationData, getApplicationData, updateSessionUser, updateSessionTokens
};

export default ApplicationAppService;
